'use client';

import { useMemo } from 'react';
import { Select, createSelectListCollection } from '@terra/ui-design-system';
import { DECODER_OPERATIONS } from './constants';
import type { DecoderOperationType } from './types';

type DecoderOperationSelectorProps = {
  value: DecoderOperationType;
  onChange: (operation: DecoderOperationType) => void;
};

export function DecoderOperationSelector({
  value,
  onChange,
}: DecoderOperationSelectorProps) {
  const collection = useMemo(() => {
    const items = Object.values(DECODER_OPERATIONS).map((op) => ({
      value: op.type,
      label: op.label,
    }));

    return createSelectListCollection({ items });
  }, []);

  return (
    <Select.Root
      size="sm"
      collection={collection}
      value={[value]}
      onValueChange={(details) => {
        const newValue = details.value[0];
        if (newValue) {
          onChange(newValue as DecoderOperationType);
        }
      }}
      positioning={{ strategy: 'fixed' }}
    >
      <Select.Trigger fontSize="xs">
        <Select.ValueText placeholder="Select operation" />
      </Select.Trigger>
      <Select.Positioner>
        <Select.Content maxHeight="300px" overflowY="auto">
          {collection.items.map((item) => (
            <Select.Item key={item.value} item={item} fontSize="xs">
              <Select.ItemText>{item.label}</Select.ItemText>
            </Select.Item>
          ))}
        </Select.Content>
      </Select.Positioner>
    </Select.Root>
  );
}
